import "./settings-modal.scss";
import { html } from "lit";
import ComponentModal from "./component-modal";
import ComponentAlert, { ALERT_TYPES } from "./component-alert";
import ConfirmationDialog from "./confirmation-dialog";
import {
  GetPrinter,
  IsChangeModalEnabled,
  IsQrCodeReaderEnabled,
  SetChangeModalEnabled,
  SetPrinter,
  SetQrCodeReaderEnabled,
} from "../assets/js/libs/utils";
import { Printers, PrintSummary, Resets } from "../assets/js/libs/api";

class SettingsModal extends ComponentModal {
  static get tagName() {
    return "settings-modal";
  }

  constructor(resolve, reject, amount) {
    super(resolve, reject);
    this.modalTitle = "Impostazioni";
    this.submitBtnText = "Salva";
    this.fullScreen = true;
    this.printers = [
      {
        iD: 999,
        name: "Printer_Name",
        description: "Printer Description",
        location: "",
        model: "Printer Model",
        status: 0,
      },
    ];
  }

  firstUpdated() {
    super.firstUpdated();
    this.GetData();
  }

  async GetData() {
    try {
      this.printers = (await Printers.GetList()).data;
      this.requestUpdate();
    } catch (error) {}
  }

  async OnRefresh() {
    await ConfirmationDialog.Show({
      heading: "Aggiorna pagina",
      message:
        "ATTENZIONE: Aggiornando la pagina perderai gli elementi nel carrello. Vuoi continuare?",
    });
    location.reload();
  }

  async OnStampaIncasso() {
    await ConfirmationDialog.Show({
      heading: "Stampa incasso",
      message: "ATTENZIONE: Stai per stampare l'incasso. Vuoi continuare?",
    });
    const printerId = GetPrinter();
    try {
      await PrintSummary(printerId);
    } catch (error) {
      ComponentAlert.Show({
        msg: html`
          <strong>Stampa non riuscita.</strong>
          <br />
          Verifica che la stampante sia accesa e connessa.
        `,
        type: ALERT_TYPES.warning,
      });
    }
  }

  async OnReset() {
    await ConfirmationDialog.Show({
      heading: "Resetta",
      message:
        "ATTENZIONE: Numeri di ritiro e incasso ripartiranno da 0. Vuoi continuare?",
    });
    try {
      await Resets.New();
      ComponentAlert.Show({
        msg: "Reset completato con successo",
        type: ALERT_TYPES.success,
      });
    } catch (error) {
      ComponentAlert.Show({
        msg: "Reset NON riuscito",
        type: ALERT_TYPES.warning,
      });
    }
  }

  get modalBody() {
    return html`
            <div class="mb-3">
                <button @click=${() => {
                  this.OnRefresh();
                }} type="button" class="btn btn-outline-primary" style="width: 180px;">
                    AGGIORNA <i class="bi bi-arrow-clockwise"></i>
                </button>
            </div>
            <div class="mb-3">
                <button @click=${() => {
                  this.OnStampaIncasso();
                }} type="button" class="btn btn-outline-secondary" style="width: 180px;">
                    STAMPA INCASSO <i class="bi bi-printer"></i>
                </button>
            </div>
            <div class="mb-3">
                <button @click=${() => {
                  this.OnReset();
                }} type="button" class="btn btn-outline-danger" style="width: 180px;">
                    RESETTA <i class="bi bi-bootstrap-reboot"></i>
                </button>
            </div>
            <form>
                <!--div class="form-group mb-3">
                    <label for="ipaddress">Indirizzo IP</label>
                    <input readonly type="text" class="form-control" id="ipaddress" placeholder="Indirizzo IP">
                    <!-\-small id="emailHelp" class="form-text text-muted">We'll never share your email with anyone else.</small-\->
                </div-->
                <!--div class="form-group mb-3">
                    <label for="macaddress">MAC Address</label>
                    <input readonly type="text" class="form-control" id="macaddress" placeholder="MAC Address">
                </div-->
                <div class="mb-3">
                    <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" id="changeModal" ?checked=${IsChangeModalEnabled()}>
                        <label class="form-check-label" for="changeModal">Abilita/disabilità interfaccia di resto</label>
                    </div>
                </div>
                <div class="mb-3">
                    <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" id="qrcodeReader" ?checked=${IsQrCodeReaderEnabled()}>
                        <label class="form-check-label" for="qrcodeReader">Abilita/disabilità lettore codice QR</label>
                    </div>
                </div>
                <div class="mb-3">
                    <label for="printer" class="form-label">Seleziona stampante</label>
                    <select id="printer" class="form-select">
                        <option value="" ?selected=${
                          GetPrinter() == ""
                        } disabled>Seleziona stampante</option>
                        ${this.printers.map(
                          (printer) => html`
                            <option
                              value=${printer.id}
                              ?selected=${GetPrinter() == printer.id}
                            >
                              ${printer.name}
                            </option>
                          `
                        )}
                    </select>
                </div>
                <!--div class="form-check">
                    <input type="checkbox" class="form-check-input" id="exampleCheck1">
                    <label class="form-check-label" for="exampleCheck1">Check me out</label>
                </div-->
            </form>
        `;
  }

  OnSubmit() {
    SetChangeModalEnabled(this.querySelector("input#changeModal").checked);
    SetQrCodeReaderEnabled(this.querySelector("input#qrcodeReader").checked);
    const selectedPrinter = this.querySelector("select#printer").value;
    if (selectedPrinter) {
      SetPrinter(selectedPrinter);
    }
    this.Hide();
  }

  get modalFooter() {
    return html`
      <button @click=${this.OnSubmit} type="button" class="btn btn-primary">
        ${this.submitBtnText}
      </button>
    `;
  }
}
SettingsModal.Register();
export default SettingsModal;
